import myaxios from "../../components/Axios";

export const getSendPulseAddressBookService = () => myaxios.get(`/ajax/integrations/sendpulse/address-book`)

export const sendPulseSubscribeService = (data) => myaxios.post(`/ajax/integrations/sendpulse/subscriber/subscribe`, data)

export const sendPulseSubUnScribeService = (data) => myaxios.post(`/ajax/integrations/sendpulse/subscriber/unsubscribe`, data)